// extracted by mini-css-extract-plugin
export var clauseRow = "_gd-6";
export var emptyState = "_gd-d";
export var filterContent = "_gd-a";
export var filterGroup = "_gd-1";
export var filterGroupContainer = "_gd-0";
export var nestedGroup = "_gd-2";
export var nestedGroupContent = "_gd-b";
export var nestedGroupDepth1 = "_gd-3";
export var nestedGroupDepth2 = "_gd-4";
export var nestedGroupDepth3 = "_gd-5";
export var nestedGroupEmpty = "_gd-c";
export var operatorAnd = "_gd-8";
export var operatorOr = "_gd-9";
export var operatorToggle = "_gd-7";
export var removeGroupButton = "_gd-e";